import React from 'react';
import { 
  Modal as UiModal, 
  LeadStatusBadge as UiLeadStatusBadge,
  ProjectStatusBadge as UiProjectStatusBadge,
  StatCard as UiStatCard,
  ProgressBar as UiProgressBar,
  EmptyState as UiEmptyState,
  SearchBar as UiSearchBar
} from '../ui';

// ─── Status Badge ────────────────────────────────────────────────────
export const LeadStatusBadge = ({ status }) => {
  return <UiLeadStatusBadge status={status} />;
};

export const ProjectStatusBadge = ({ status }) => {
  return <UiProjectStatusBadge status={status} />;
};

// ─── Modal ───────────────────────────────────────────────────────────
export const Modal = ({ isOpen, onClose, title, children, size = 'md', closeIcon = 'close' }) => {
  // Map common size variants ('sm', 'md', 'lg', 'xl') to UI modal size variants
  const sizeMap = {
    sm: 'sm',
    md: 'lg',
    lg: 'xl',
    xl: '2xl'
  };
  return (
    <UiModal isOpen={isOpen} onClose={onClose} title={title} size={sizeMap[size] || size} closeIcon={closeIcon}>
      {children}
    </UiModal>
  );
};

// ─── Stat Card ───────────────────────────────────────────────────────
export const StatCard = ({ title, value, sub, subtitle, icon, color = 'orange', trend, variant, imageSrc, illustration, badge, trendArrow, topColor, iconHoverColor }) => {
  // Map legacy color strings to tailwind brand colors used by UI component icon container
  const colorMap = {
    orange: 'bg-blum-orange',
    green: 'bg-emerald-500',
    blue: 'bg-blue-500',
    purple: 'bg-purple-500',
    red: 'bg-red-500',
  };
  const resolvedColor = colorMap[color] || 'bg-blum-orange';
  
  return (
    <UiStatCard 
      title={title} 
      value={value} 
      sub={sub || subtitle} 
      icon={icon} 
      color={resolvedColor} 
      trend={trend} 
      variant={variant}
      imageSrc={imageSrc}
      illustration={illustration}
      badge={badge}
      trendArrow={trendArrow}
      topColor={topColor}
      iconHoverColor={iconHoverColor}
    />
  );
};

// ─── Progress Bar ────────────────────────────────────────────────────
export const ProgressBar = ({ value, color = 'bg-blum-orange', label }) => {
  return <UiProgressBar value={value} label={label} />;
};

// ─── Empty State ─────────────────────────────────────────────────────
export const EmptyState = ({ icon, title, desc, action }) => {
  return <UiEmptyState icon={icon} title={title} description={desc} action={action} />;
};

// ─── Search Bar ──────────────────────────────────────────────────────
export const SearchBar = ({ value, onChange, placeholder = 'Search...' }) => {
  return <UiSearchBar value={value} onChange={onChange} placeholder={placeholder} />;
};

// ─── Format Helpers ───────────────────────────────────────────────────
export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

import OnlyOfficeEditor from './OnlyOfficeEditor';
export { OnlyOfficeEditor };
